import { getCookie } from '@/app/utils/client-cookies'
import { getHealthQuoteFromTokenOrNull, postValidateLanding } from '@/app/endpoints/healthComparatorEndpoints'
import { STORED_TOKEN_COOKIE } from './health-form.constants'
import { STEP_FAMILY_TYPE } from './health-form-steps.constants'

export interface ILandingAnswers {
    familyType: number
    birthdate?: string
}

// Same priority as /devis-mutuelle-sante and its [token]/[step] guard, whose redirect would drop the answers: stored quote, then the page's quote, else a new one.
export async function resolveLandingQuoteToken(originRoute: string, pageToken?: string | null): Promise<string | null> {
    const storedToken = getCookie(STORED_TOKEN_COOKIE)
    if (storedToken && await getHealthQuoteFromTokenOrNull(storedToken)) return storedToken
    if (pageToken && await getHealthQuoteFromTokenOrNull(pageToken)) return pageToken

    try {
        const data = await postValidateLanding({
            abTestReviewsVersion: null,
            token: null,
            assignToExpert: null,
            partnerSource: null,
            originRoute,
        })
        return data?.token ?? null
    } catch {
        return null
    }
}

export const landingHandoffUrl = (token: string, { familyType, birthdate }: ILandingAnswers): string => {
    const params = new URLSearchParams({ familyType: String(familyType), comesFromLanding: 'true' })
    if (birthdate) params.set('birthdate', birthdate)
    return `/devis-mutuelle-sante/${token}/${STEP_FAMILY_TYPE}?${params.toString()}`
}
